import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    subscription!: Subscription;

    constructor(private primengConfig: PrimeNGConfig, private translateService: TranslateService) { }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.translateService.setDefaultLang('it');
        this.translateService.use('it');
        this.subscription = this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));

    }

   
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}
